import {
  GET_PENDING_ACTIVITY_SUMMARY,
  GET_SEATING_ACTIVITY_SUMMARY,
  GET_ALL_SEATING_DASHBOARD_SUMMARY,
  GET_ALL_COUNT_SUMMARY_REPORTS,
  GET_ALL_VENDOR_SEATING_DINER_RECORDS,
  GET_ALL_VENDOR_PENDING_DINER_RECORDS,
  GET_ALL_VENDOR_RESERVATION_DINER_RECORDS,
  GET_ALL_VENDOR_HISTORY_DINER_RECORDS,
  // INC_SEATING_COUNT,
  // DEC_SEATING_COUNT,
  STORE_VENDOR_ID_SUPERADMIN,
} from "../../types";

const initialState = {
  get_pending_activity_summary: "",
  get_seating_activity_summary: "",
  get_all_seating_dashboard_summary: [],
  get_all_seating_count_reports: [],
  vendor_all_diner: [],
  vendor_all_pending_diner: [],
  vendor_all_reservation_diner: [],
  vendor_all_history_diner: [],
  set_super_admin_vendor_id: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_PENDING_ACTIVITY_SUMMARY:
      return {
        ...state,
        get_pending_activity_summary: action.payload,
      };
    case GET_SEATING_ACTIVITY_SUMMARY:
      return {
        ...state,
        get_seating_activity_summary: action.payload,
      };
    case GET_ALL_SEATING_DASHBOARD_SUMMARY:
      return {
        ...state,
        get_all_seating_dashboard_summary: action.payload,
      };
    case GET_ALL_COUNT_SUMMARY_REPORTS:
      return {
        ...state,
        get_all_seating_count_reports: action.payload,
      };
    case GET_ALL_VENDOR_SEATING_DINER_RECORDS:
      return {
        ...state,
        vendor_all_diner: action.payload,
      };
    case GET_ALL_VENDOR_PENDING_DINER_RECORDS:
      return {
        ...state,
        vendor_all_pending_diner: action.payload,
      };
    case GET_ALL_VENDOR_RESERVATION_DINER_RECORDS:
      return {
        ...state,
        vendor_all_reservation_diner: action.payload,
      };
    case GET_ALL_VENDOR_HISTORY_DINER_RECORDS:
      return {
        ...state,
        vendor_all_history_diner: action.payload,
      };
    // case INC_SEATING_COUNT:
    //   return {
    //     ...state,
    //     vendor_all_diner: {
    //       ...state.vendor_all_diner,
    //       total: state.vendor_all_diner.total + 1,
    //     },
    //   };
    // case DEC_SEATING_COUNT:
    //   return {
    //     ...state,
    //     vendor_all_diner: {
    //       ...state.vendor_all_diner,
    //       total: state.vendor_all_diner.total - 1,
    //     },
    //   };
    case STORE_VENDOR_ID_SUPERADMIN:
      return {
        ...state,
        set_super_admin_vendor_id: action.payload,
      };
    default:
      return state;
  }
}
